import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { SatHachs_DeThi, KhoaHocs_KhoaHoc } from '../../../routes/menu';
import { Router, ActivatedRoute } from '@angular/router';
import { Repository } from '../../../services/repository'
import { Global, BaoCao } from '../../../shared/global';


//import printJS from 'print-js';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { ToolbarService, LinkService, ImageService, HtmlEditorService } from '@syncfusion/ej2-angular-richtexteditor';
import { RichTextEditorComponent, TableService, FileManagerService } from '@syncfusion/ej2-angular-richtexteditor';
import { FileManagerSettingsModel, QuickToolbarSettingsModel } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';


import 'jquery'
import 'bootstrap'
import { elementAt } from 'rxjs/operators';


const swal = require('sweetalert');
@Component({
  selector: 'app-baiviet-baivietcheck',
  templateUrl: './baivietcheck.component.html',    
  providers: [ListService, Repository, MaskedDateTimeService, ToolbarService, LinkService, ImageService, HtmlEditorService, TableService, FileManagerService]
})


export class baivietcheckComponent implements OnInit {
  private hostUrl: string = '/';
  alertMsg: any;
  @ViewChild('toolsRTE')
  public rteObj: RichTextEditorComponent;
  public tools: ToolbarModule = {
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', 'SuperScript', 'SubScript', '|',
      'Formats', 'Alignments', 'NumberFormatList', 'BulletFormatList',
      'Outdent', 'Indent', '|',
      'CreateTable', 'CreateLink', 'Image', 'FileManager', '|', 'ClearFormat', 'Print',
      'SourceCode', 'FullScreen', '|', 'Undo', 'Redo']
  };

  public fileManagerSettings: FileManagerSettingsModel = {
    enable: true,
    path: '',
    ajaxSettings: {
      url: this.hostUrl + 'FileManager/FileOperations',
      getImageUrl: this.hostUrl + 'FileManager/GetImage',
      uploadUrl: this.hostUrl + 'FileManager/Upload',
      downloadUrl: this.hostUrl + 'FileManager/Download'
    }
  };

  public quickToolbarSettings: QuickToolbarSettingsModel = {
    table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
  };
  public width: string = '98%';
  public animationSettings: AnimationSettingsModel = { effect: 'None' };
  public target: string = '.control-section';
  public maxLength = 20000;
  public textArea: HTMLElement;
  public myCodeMirror: any;
  public value: any;





  msg: string;
  //@ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('dteChung') doituongchungedit: any;

  //@ViewChild('modalngayhethan', { static: false }) modalngayhethan: ModalComponent;
  @ViewChild('dtengayhethan') dtengayhethan: any;

  // @ViewChild('modalimport', { static: false }) modalimport: ModalComponent;
  @ViewChild('dtimportexcel') importedit: any;

  indLoading: boolean = false;
  hienthitatca: boolean = false;
  intudong: boolean = false;
  intudong1: boolean = false;
  thoigian: any;
  myVar: any;
  datas: any = {};
  modalTitle: string;
  modalBtnTitle: string;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  quyen_suabaitap: boolean = false;
  huongdan: string;

  idFocus: string = '00000000-0000-0000-0000-000000000000';
  nhomdoituongid: string = null;
  doituongid: any = null;
  donviid: string = null;
  currentUser: any;
  headerTitle: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
 


  chongioitinhs: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Nữ" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Nam" }];

  tranthais: any = [{ Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Đang thi" }
    , { Id: 2, Ma_Doi_Tuong: "2", Ten_Doi_Tuong: "Thi đạt" }
    //, { Id: 3, Ma_Doi_Tuong: "3", Ten_Doi_Tuong: "Đã đạt" }
    , { Id: 4, Ma_Doi_Tuong: "4", Ten_Doi_Tuong: "Thi trượt" }
    , { Id: 5, Ma_Doi_Tuong: "5", Ten_Doi_Tuong: "Chưa thi" }

  ];

  hoatdongs: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Hoạt động" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Khóa hồ sơ" }
  ];

  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 500;
  public pageSize: number = 500;
  public pages: any;
  public totalPages: number;
  username: any;
  public TimKiems: any = {
    DonViId: null
    , UserName: null
    , TuNgay: null
    , DenNgay: null
    , TimKiem: null
    , startPage: null
    , endPage: null
    , HoVaTen: null
    , MaNV: null
    , Ngay: null
    , NgayS: null
    , SoCMND: null
    , IDGioiTinh: null
    , DiaChi: null
    , PhongBan: null
    , DonVi: null
    , MaKhoanLuong: null
    , NgayApDung: null
    , NgayApDungS: null
    , HeSo: null
    , SoTien: null
    , Loai: 7
    , KhoaThi: null
    , TrangThai: null
    , HoatDong: null
    , HienThiTatCa: false

  };
  public ngaytimkiem: Date = new Date();
  public ngaytimkiem_apdung: Date = new Date();
  TichTatCa() {
    this.datas.forEach((item: any) => {
      item.Tich = !this.TatCa;
    });
  }
 
  InTuDong() {
    this.intudong = !this.intudong1;
    if (this.intudong == true)
      this.myFunction();
    else
      location.reload();
  }
  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }
  public length: number = 0;
  canboid: any;
  baitapid: any;
  timeOut: any;
  phut: string;
  giay: string;
  tbatdau: boolean = true;
  thoigianlambai: number = 180;
  thoigianlambais: string;
  batdau() {
    this.tbatdau = false;
    this.timeOut = this.thoigianlambai;
    let countdown = setInterval(() => {
      this.timeOut = this.timeOut - 1;
      let minute = Math.floor(this.timeOut / 60);
      let second = this.timeOut % 60;
      //console.log("ttttf2");
      //console.log(this.timeOut
      let minute1 = minute < 10 ? "0" + minute.toString() : minute.toString();
      let second1 = second < 10 ? "0" + second.toString() : second.toString();
      document.getElementById("spanTimeout").innerHTML = minute1 + ":" + second1;
      this.datas.spanTimeout1 = minute1 + ":" + second1;
      if (this.timeOut == 0) {
        clearInterval(countdown);
        this.savect();
        // alert("Hết thời gian");
        //$("#ipKetThuc").click();
      }
    }, 1000);

  }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  constructor(private route: ActivatedRoute, private _dataService: ListService, public repo: Repository) {

    this.ngaytimkiem = null;
    this.ngaytimkiem_apdung = null;

   
  }
  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    if (this.currentUser) {

      this.currentUser = JSON.parse(this.currentUser);
      this.donviid = this.currentUser.id_don_vi;
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === SatHachs_DeThi.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }

      giatri = this.currentUser.ds_quyen.filter(name => name.Id === KhoaHocs_KhoaHoc.id.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Sua == true)
          this.quyen_suabaitap = true;
        else
          this.quyen_suabaitap = false;
      }

    }
  }

  export_auto() {
    console.log(this.currentUser);
    let kieuin = 'pdf';
    let idbaocao = '2FEB1C53-8465-474C-B2C9-8B1A42519BE0';
    this.msg = "";
    let data = {
      Id: idbaocao,
      Type: kieuin,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , DoiTuong: null
        , MauBaoCao: 3
      })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "bao_cao.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {

          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            // window.open(fileURL, "EPrescription","",true);



            var iframe = document.createElement('iframe');
            document.body.appendChild(iframe);
            iframe.style.display = 'none';
            iframe.id = "printf";
            iframe.name = "printf";
            iframe.src = fileURL;
            setTimeout(function () {
              var ua = window.navigator.userAgent;
              var msie = ua.indexOf("MSIE ");
              console.log("ds_ds");
              console.log(ua);
              console.log(iframe);
              console.log(iframe.contentWindow.document);
              if (msie > 0) {
                iframe.contentWindow.document.execCommand("print", false, null);
              }
              else {
                iframe.contentWindow.document.execCommand("print", false, null);
              }
            }, 1000);



            // iframe.onload = function () {
            //   setTimeout(function () {
            //     iframe.focus();
            //     if (iframe.contentWindow.document.queryCommandSupported("print")) {
            //       iframe.contentWindow.print();
            //       iframe.contentWindow.document.execCommand("print", false, null);
            //     } else {
            //       iframe.contentWindow.focus();
            //       iframe.contentWindow.print();
            //     }

            //   }, 1);
            // }; 
            //iframe.src = fileURL;



            //if (window.navigator.userAgent.indexOf("MSIE") > 0) {

            //}
            //else {
            //  iframe.contentWindow.focus();
            //  iframe.contentWindow.print();
            //}

            //window.frames["printf"].focus();
            //window.frames["printf"].print();
            //var newWin = window.frames["printf"];
            //newWin.document.write('<body onload="window.print()">dddd</body>');
            //newWin.document.close();

          }

        });
    }



  }

  ten_tep_mau: string = 'tep_mau_danh_muc';


  myFunction() {
    if (this.thoigian != null && this.thoigian != 0 && this.thoigian != -1000) {
      this.myVar = setInterval(() => {
        this.export_auto();
      }, this.thoigian)
    }
  }


 
  loadDataInit(baitapid, username) {
    this.baitapid = baitapid;
    this.username = username;
    this.Loaddatas();
  }
  
  Loaddatas(): void {
    this.repo.postRequest("api/dethi/baithi", { BaiTapId: this.baitapid, UserName: this.username })
      .subscribe(response => {
        if (response.TrangThai == 1) {
          swal('Cảnh báo!', response.TrangThaiS, 'warning');
        }
        else {
          this.datas = response;
          if (this.datas.DaThi == 0)
            this.tbatdau = true;
          else
            this.tbatdau = false;

          if (this.datas.Loai === 6) {
            this.tbatdau = false
          } else {

            this.thoigianlambai = this.datas.ThoiGianLamBai;
            let minute = Math.floor(this.datas.ThoiGianLamBai / 60);
            let second = this.datas.ThoiGianLamBai % 60;

            let minute1 = minute < 10 ? "0" + minute.toString() : minute.toString();
            let second1 = second < 10 ? "0" + second.toString() : second.toString();
            if (second1 == "00")
              this.thoigianlambais = minute1 + " phút ";
            else
              this.thoigianlambais = minute1 + " phút " + second1 + " giây";
          }


        }
      });
  }
  rowSelected: any = null;

  //------------------------------------
  selectedRows: any;
  onRowSelect(event) {
    this.selectedRows = event.selected;
  }
  public savect() {
    this.repo.postRequest("api/dethi/addorupdate_baithi", this.datas)
      .subscribe(response => {
        if (response != null && response.match('-')) {
          this.Loaddatas();
        }
        else
          swal('Cảnh báo!', response, 'warning');

      });
  }



  saveModal(id: any) {
    console.log(id);
    this.Loaddatas();
    //this.modal.dismiss();
    //this.modalngayhethan.dismiss();
  }

  deletedata(id: string) {

    console.log(id);



    swal({
      title: 'Bạn muốn xóa bản ghi?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          //console.log("data");
          //console.log(id);
          this.repo.postRequest('api/dethi/delete_baithi/', { IdGuid: id, PhanHeId: this.nhomdoituongid, UserName: this.currentUser.user_name }).subscribe(
            data => {
              if (data == "OK") //Success
              {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');

                this.Loaddatas();
              }
              else {
                // this.msg = data;
                swal('Cảnh báo!', data, 'warning');
              }


            },
            error => {
              this.msg = error;
            }
          );
        }
      });


  }
  public khoadoituong(loaikhoa) {
    //loaikhoa =1 là khóa
    //loaikhoa =0 là mở khóa
    let thongbao1 = "";
    if (loaikhoa == 1) {
      thongbao1 = "Bạn có muốn khóa đối tượng?";
    }
    else {
      thongbao1 = "Bạn có muốn mở đối tượng?";
    }
    let dsid = null;
    this.datas.forEach((item: any) => {
      if (item.Tich == true) {
        if (dsid == null)
          dsid = item.Id;
        else
          dsid = dsid + "," + item.Id;
      }
    });

    if (dsid == null) {
      if (loaikhoa == 1) {
        swal('Cảnh báo!', 'Chưa chọn đối tượng để khóa!.', 'warning');
        thongbao1 = "Bạn có muốn khóa đối tượng?";
      }
      else {
        swal('Cảnh báo!', 'Chưa chọn đối tượng để mở!.', 'warning');
        thongbao1 = "Bạn có muốn mở đối tượng?";
      }
      return;
    }
    $('#loading').show();
    let data = {
      Id: BaoCao.BC05_PhieuChungTu,
      Type: "",
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdDoiTuong: dsid
        , LoaiKhoa: loaikhoa

      })
    };

    swal({
      title: thongbao1,
      text: '',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-success",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest('api/danhsachthi/khoadoituong/', data).subscribe(
            data => {
              $('#loading').hide();
              if (data == "OK") //Success
              {
                swal('Cập nhật!', 'Dữ liệu đã được cập nhật!.', 'success');

                this.Loaddatas();
              }
              else {
                // this.msg = data;
                swal('Lỗi!', data, 'warning');
              }
            },
            error => {
              this.msg = error;
            }
          );

        }
      });


    $('#loading').hide();


  }

  public xoadoituong(loai) {
    //loaikhoa =1 là khóa
    //loaikhoa =0 là mở khóa
    let thongbao1 = "";
    if (loai == 1) {
      thongbao1 = "Bạn có muốn xóa kết quả thi của đối tượng?";
    }
    else {
      thongbao1 = "Bạn có muốn xóa danh sách và kết quả thi của đối tượng?";
    }
    let dsid = null;
    this.datas.forEach((item: any) => {
      if (item.Tich == true) {
        if (dsid == null)
          dsid = item.Id;
        else
          dsid = dsid + "," + item.Id;
      }
    });

    if (dsid == null) {
      if (loai == 1) {
        swal('Cảnh báo!', 'Chưa chọn đối tượng để xóa!.', 'warning');
        thongbao1 = "Bạn có muốn xóa kết quả của đối tượng?";
      }
      else {
        swal('Cảnh báo!', 'Chưa chọn đối tượng để xóa!.', 'warning');
        thongbao1 = "Bạn có muốn xóa danh sách và kết quả đối tượng?";
      }
      return;
    }
    $('#loading').show();
    let data = {
      Id: BaoCao.BC05_PhieuChungTu,
      Type: "",
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , IdDoiTuong: dsid
        , LoaiKhoa: loai

      })
    };

    swal({
      title: thongbao1,
      text: '',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-success",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.postRequest('api/danhsachthi/xoadoituong/', data).subscribe(
            data => {
              $('#loading').hide();
              if (data == "OK") //Success
              {
                swal('Cập nhật!', 'Xóa dữ liệu hoàn thành!.', 'success');

                this.Loaddatas();
              }
              else {
                // this.msg = data;
                swal('Lỗi!', data, 'warning');
              }
            },
            error => {
              this.msg = error;
            }
          );

        }
      });


    $('#loading').hide();


  }

  public ChoThiTiep() {
    let dsid = null;
    this.datas.forEach((item: any) => {
      if (item.Tich == true) {
        if (dsid == null)
          dsid = item.Id;
        else
          dsid = dsid + "," + item.Id;
      }
    });
    if (dsid != null) {
      swal({
        title: "Bạn có muốn cho cán bộ tiếp tục thi?",
        text: '',
        icon: "warning",
        buttons: {
          cancel: {
            text: 'Hủy bỏ',
            value: false,
            visible: true,
          },
          confirm: {
            text: 'Đồng ý',
            value: true,
            visible: true,
            className: "bg-success",
            closeModal: true
          }
        }
      })
        .then(willDelete => {
          if (willDelete) {
            this.repo.postRequest('api/danhsachthi/chothitiep/', { UserName: this.currentUser.user_name, GhiChu: dsid }).subscribe(
              data => {
                swal('Cập nhật!', 'Hoàn thành!.', 'success');
                this.Loaddatas();
                return;
              },
              error => {
                this.msg = error;
              }
            );

          }
        });
    }

  }
  public Email() {
    let dsid = null;
    this.datas.forEach((item: any) => {
      if (item.Tich == true) {
        if (dsid == null)
          dsid = item.Id;
        else
          dsid = dsid + "," + item.Id;
      }
    });
    if (dsid != null) {
      swal({
        title: "Bạn có muốn gửi thông tin thi cho cán bộ đã chọn?",
        text: '',
        icon: "warning",
        buttons: {
          cancel: {
            text: 'Hủy bỏ',
            value: false,
            visible: true,
          },
          confirm: {
            text: 'Đồng ý',
            value: true,
            visible: true,
            className: "bg-success",
            closeModal: true
          }
        }
      })
        .then(willDelete => {
          if (willDelete) {
            this.repo.postRequest('api/danhsachthi/email/', { UserName: this.currentUser.user_name, GhiChu: dsid }).subscribe(
              data => {
                if (data == "OK") {
                  swal('Cập nhật!', 'Gửi email hoàn thành!.', 'success');
                  this.Loaddatas();
                  return;
                }
                else {
                  swal('Cảnh báo!', data, 'warning');
                }
              },
              error => {
                this.msg = error;
                swal('Cảnh báo!', this.msg, 'warning');
              }
            );

          }
        });
    }

  }
 
  

}

